module.exports = __webpack_public_path__ + "static/media/conduct-policy.533680e8.svg";